import React from "react";
import { AlertContext } from "../contexts/AlertContext";
import TextCellInfo from "./gridCells/TextCellInfo";
import { ActionResult } from "../interfaces/ActionResult";
import { AlertType } from "../types/AlertTypes";
import { CharacterSheetContext } from "../contexts/CharacterSheetContext";

interface Props {
  itemKey: string;
  alertType: AlertType;
}

export default ({ itemKey, alertType }: Props) => {
  const { getKey, getAlerts } = React.useContext(AlertContext);
  const { alertLevel, showAllAlerts } = React.useContext(CharacterSheetContext);

  const alerts = getAlerts(alertType, itemKey, showAllAlerts, alertLevel).map(
    (alert: ActionResult, index: number) => {
      const alertId = `${getKey(alertType, itemKey)}-${index}`;
      return (
        <TextCellInfo
          key={alertId}
          dataTest={alertId}
          text={alert.message}
          classes={`grid-cell-fill ${alert.success ? "" : "warning"}`}
        />
      );
    }
  );

  return <>{alerts}</>;
};
